import request from '@/utils/request'
import URL from './urlTranslator'

export function getRoleByUuid(uuid) {
  const params = { uuid }
  return request({
    url: `${URL.sys.role}`,
    method: 'get',
    params
  })
}

export function batchAddRolePermission(data) {
  return request({
    url: `${URL.sys.batchAddRolePermission}`,
    method: 'put',
    data
  })
}

export function batchDelRole(data) {
  return request({
    url: `${URL.sys.role}`,
    method: 'delete',
    data
  })
}

export function saveRole(data) {
  return request({
    url: URL.sys.role,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function validateRoleByUserIdAndRoleName(data) {
  return request({
    url: URL.sys.validateRoleByUserIdAndRoleName,
    method: 'post',
    data
  })
}

// 获取角色操作职责主键列表
export function getOperationResponsibilityKeys(params) {
  return request({
    url: URL.sys.getOperationResponsibilityKeys,
    method: 'get',
    params
  })
}

// 保存角色操作职责
export function saveOperationResponsibilities(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.saveOperationResponsibilities,
    method: 'post',
    data
  })
}

// 获取角色
export function getRoleList(params) {
  return request({
    url: URL.sys.getRoleList,
    method: 'get',
    params
  })
}
